import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "webuild-feature-workspace-rail-collapsed"

export default class extends Controller {
  static targets = ["toggle", "collapseIcon", "expandIcon"]

  connect() {
    this.workspace = this.element.closest(".feature-workspace")
    this.apply(this.storedState())
  }

  toggle() {
    const collapsed = !this.workspace?.classList.contains("is-rail-collapsed")
    this.apply(collapsed)

    try {
      window.localStorage.setItem(STORAGE_KEY, collapsed ? "true" : "false")
    } catch (_) {
      // The control still works when browser storage is unavailable.
    }
  }

  apply(collapsed) {
    if (!this.workspace) return

    this.workspace.classList.toggle("is-rail-collapsed", collapsed)
    this.toggleTarget.setAttribute("aria-expanded", collapsed ? "false" : "true")
    this.toggleTarget.setAttribute("aria-label", collapsed ? "Expand planning navigation" : "Collapse planning navigation")
    this.toggleTarget.setAttribute("title", collapsed ? "Expand navigation" : "Collapse navigation")
    this.collapseIconTarget.hidden = collapsed
    this.expandIconTarget.hidden = !collapsed
  }

  storedState() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "true"
    } catch (_) {
      return false
    }
  }
}
